/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import AppFavIcon from 'DesignSystem/AppFavIcon/react'
import AppTitle from 'DesignSystem/AppTitle/react'
import CountBubble from 'DesignSystem/CountBubble/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Comms/Status/Content"
  
}) {
let commsThreadsAggregateValueData = fromData.useDataValue({ viewPath,
context: 'comms_threads_aggregate',
})
let commsThreadsAggregateValueData1 = fromData.useDataFormat({ viewPath,
context: 'comms_threads_aggregate',
format: fromFormat.unreadThreadsCount,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<CountBubble
  viewPath={`${viewPath}/CountBubble`}
 backgroundColor="rgba(255,131,0, 1)"
 marginTop={0}
 marginLeft={0}
 data="comms_threads_aggregate"
 text={commsThreadsAggregateValueData}
/>
</div>
<AppFavIcon
  viewPath={`${viewPath}/AppFavIcon`}
 url="/favicon-new-threads.ico"
/>
<AppTitle
  viewPath={`${viewPath}/AppTitle`}
 data="comms_threads_aggregate"
 format="/Data/format.js unreadThreadsCount"
 text={commsThreadsAggregateValueData1}
/>
{children}
</React.Fragment>)
}